import { sendTestMatomoEvent } from "./matomoTest";

export const handleVideoNavigationEvent = async ({
  type,              // "rewind" | "forward" | "seek"
  delta = 0,         // -10 | +10 (ignored for seek)
  newTime,           // required for seek
  itemDetails,
  itemData,
  CurrentItemData,
  currentTime,
}) => {
  const ctx = buildContext({
    itemDetails,
    itemData,
    CurrentItemData,
  });

  console.log(ctx, "checkingTimes");

  if (!ctx) return;

  const fromTime = parseInt(currentTime, 10);
  const toTime = type === "seek" ? newTime : fromTime + delta;

  const impressionAction = buildActionName(ctx, fromTime);
  const interactionAction = buildActionName(ctx, toTime);

  if (!impressionAction || !interactionAction) return;

  await sendTestMatomoEvent(
    { action_name: interactionAction },
    {
      eventType: "content_interaction",
      c_i: buildInteractionLabel(type, fromTime, toTime),
    }
  );

  await sendTestMatomoEvent(
    { action_name: impressionAction },
    {
      eventType: "content_impression",
    }
  );
};

  function formatSecondsToHMS(seconds) {
    console.log(seconds, "seconds1");
    const hrs = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const mins = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const secs = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  }


const buildContext = ({ itemDetails, itemData, CurrentItemData }) => {
    console.log("checkingTimes")
  const mediaTypeMap = ["VOD", "SVOD", "TVOD"];

  const mediaType =
    mediaTypeMap[itemDetails?.[0]?.is_paid] ?? "Unknown";

  const videoType = itemDetails?.[0]?.category_title;
  if (!videoType) return null;

  const itemId = itemData?.id ?? itemData?.show_id;
  const itemTitle = itemData?.title ?? "";
  const currentTitle = CurrentItemData?.title ?? "";
  const currentId =
    CurrentItemData?.id ?? itemData?.id ?? itemData?.show_id;

  const season = itemDetails?.[0]?.season?.[0];
  const seasonId = season?.id;
  const seasonNumber = season?.number;

  const episodeNumber =
    (season?.videos?.findIndex(v => v.id === currentId) ?? -1) + 1 || 1;

  const genres = itemData?.genres ?? itemDetails?.[0]?.genres ?? "";

  return {
    mediaType,
    videoType,
    itemId,
    itemTitle,
    currentTitle,
    currentId,
    seasonId,
    seasonNumber,
    episodeNumber,
    genres,
  };
};


const buildActionName = (ctx, timeInSeconds) => {
  const time = formatSecondsToHMS(timeInSeconds);
  console.log(ctx,"buildActionName")

  if (ctx.videoType === "Shows") {
    return `${ctx.itemId}/${ctx.itemTitle}-S${ctx.seasonNumber} E${ctx.episodeNumber} ${ctx.currentTitle}(${ctx.mediaType})/WebSeries/${ctx.seasonId}/${ctx.seasonNumber}/${ctx.currentId}/${ctx.currentTitle}/${time}-${ctx.genres}`;
  }

  if (ctx.videoType === "Movies" || ctx.videoType === "Shorts") {
    return `${ctx.itemId}/${ctx.itemTitle}-${ctx.itemTitle}(${ctx.mediaType})/Movie/${time}-${ctx.genres}`;
  }
  

  return null;
};



const buildInteractionLabel = (type, from, to) => {
  const fromTime = formatSecondsToHMS(from);
  const toTime = formatSecondsToHMS(to);

  console.log(from,to,"checkingTime")

  switch (type) {
    case "rewind":
      return `Video/Rewind/(From ${fromTime}/Rewind: 10 Seconds To ${toTime})`;

    case "forward":
      return `Video/Forward/(From ${fromTime}/Forward: 10 Seconds To ${toTime})`;

    case "seek":
      return `Video/Seekbar/(From ${fromTime}/ To ${toTime})`;

    default:
      return "";
  }
};



// matomoPlayPauseEvent.js

export const motamoPlayPauseEvent = async ({
  eventActionStatus,
  itemDetails,
  itemData,
  CurrentItemData,
  videoRef,
  currentTime,
  sourceContext,
}) => {
  if (!itemDetails?.length) return;

  // ----- media type -----
  const isPaid = itemDetails[0]?.is_paid;
  const mediaType =
    isPaid === 0 ? "VOD" :
    isPaid === 1 ? "SVOD" :
    isPaid === 2 ? "TVOD" :
    "Unknown";

  const videoType = itemDetails[0]?.category_title;

  // ----- ids & titles -----
  const itemId = itemData?.id ?? itemData?.show_id;
  const itemTitle = itemData?.title ?? "";
  const currentTitle = CurrentItemData?.title ?? "";
  const currentId =
    CurrentItemData?.id ??
    itemData?.id ??
    itemData?.show_id;

  // ----- season / episode -----
  const season = itemDetails?.[0]?.season?.[0];
  const seasonId = season?.id;
  const seasonNumber = season?.number;

  const episodeNumber =
    (season?.videos?.findIndex(v => v.id === currentId) ?? -1) + 1 || 1;

  // ----- time -----
   const actualCurrentTime = currentTime ?? 0;

  const formattedTime = formatSecondsToHMS(
    Math.floor(actualCurrentTime)
  );

  // ----- event build -----
  let eventCategory = "";
  let eventName = "";

  if (videoType === "Shows" && currentTitle && currentId) {
    eventCategory = "Video";
    eventName = `${itemId}/${itemTitle}-S${seasonNumber} E${episodeNumber} ${currentTitle}(${mediaType})/WebSeries/${seasonId}/${seasonNumber}/${currentId}/${currentTitle}/${formattedTime}`;
  } else {
    switch (videoType) {
      case "TV Channels":
      case "Live":
        eventCategory = "LiveChannel";
        eventName = `${itemId}/${itemTitle}`;
        break;

      case "Movies":
      case "Shorts":
        eventCategory = "Video";
        eventName = `${itemId}/${itemTitle}-${itemTitle}(${mediaType})/Movie/${formattedTime}`;
        break;

      default:
        return;
    }
  }

  // ----- send matomo -----
  await sendTestMatomoEvent({
    eventCategory,
    eventAction: eventActionStatus,
    eventName,
    sourceContext: sourceContext || "",
  });

  // ----- live channel -----
  if (videoType === "TV Channels" || videoType === "Live") {
    await sendLiveChannelEvent({
      actionType: eventActionStatus,
      itemData,
      itemDetails,
    });
  }
};



export const mediaPlayBackMotamoEvent = async ({
  videoElement,
  watchedSeconds = 0,
  mediaId,
  CurrentItemData,
  itemData,
  itemDetails,
  DrmInformatin,
  GetVideoUrlData,
}) => {
  if (!videoElement) return console.log("Video element not ready");

  const currentTime = videoElement.currentTime;
  const duration = videoElement.duration;

  if (!duration || !mediaId) {
    console.log("Dependencies not ready:", {
      hasCurrentTime: !!currentTime,
      hasDuration: !!duration,
      hasMediaId: !!mediaId,
    });
    return;
  }

     console.log(
      "Starting mediaPlayBackMotamoEvent",
      itemDetails?.[0],
      mediaId,
      parseInt(watchedSeconds)
    );

  // DON'T send heartbeat when paused
  if (videoElement.paused) {
    console.log("mediaPlayBackMotamoEvent: video is paused — skipping");
    return;
  }

  const currentVideoId =
    CurrentItemData?.id ?? itemData?.id ?? itemData?.show_id;
  const season = itemDetails?.[0]?.season?.[0];
  const currentSeasonNumber = season?.number || 1;
  const videos = season?.videos || [];

  const episodeIndex = videos.findIndex((v) => v.id === currentVideoId);
  const episodeNumber = episodeIndex >= 0 ? episodeIndex + 1 : 1;

  // Episode title
  const episodeTitle =
    episodeIndex >= 0 ? videos[episodeIndex]?.title || CurrentItemData.title : "";

  const isLive =
    itemDetails?.[0]?.category_title === "Live" ||
    itemDetails?.[0]?.category_title === "TV Channels";

  // First event — send heartbeat
  await sendTestMatomoEvent(
    { action_name: `video_play` },
    {
      eventType: "media_action",
      mediaLength: isLive ? 0 : parseInt(duration),
      mediaId: mediaId,
      mediaUrl: DrmInformatin?.data?.file_url || GetVideoUrlData[0]?.file_url || "-",
      mediaType: "Video",
      mediaTitle:
        itemDetails?.[0]?.category_title === "TV Channels"
          ? `${itemData?.show_id ?? itemData?.id}/${itemData?.title}`
          : itemDetails?.[0]?.season?.[0]?.number && CurrentItemData?.title
          ? `${itemData?.show_id ?? itemData?.id}/${itemData?.title}-S${currentSeasonNumber} E${episodeNumber} ${episodeTitle}`
          : `${itemData?.show_id ?? itemData?.id}/${itemData?.title}-${itemData?.title}`,

      mediaPlayer: "html5video",
      mediaInSecond: parseInt(watchedSeconds),
      mediaPlaytime: parseInt(watchedSeconds),
      mediaProgress: parseInt(watchedSeconds),
      isinFullScreen: 1,
    }
  );
};

 export const sendWatchListEvent = async ({
    actionType, // Play, Pause, Resume, Stop
    itemData,
    itemDetails,
  }) => {
    console.log("checkingMedia", itemData, itemDetails);
    const genres = itemDetails?.[0]?.genres;
    const actionName = genres
      ? `${itemData?.show_id}/${itemData?.title}-${genres}`
      : `${itemData?.show_id}/${itemData?.title}`;
    const ciValue = `Watchlist/${actionType}`;

    // Event
    await sendTestMatomoEvent({
      eventCategory: "Watchlist",
      eventAction: actionType,
      eventName: `${itemData?.show_id}/${itemData?.title}`,
    });

    // Interaction
    await sendTestMatomoEvent(
      {
        action_name: actionName,
      },
      {
        eventType: "content_interaction",
        c_i: ciValue,
      }
    );

    // Impression
    await sendTestMatomoEvent(
      {
        action_name: actionName,
      },
      {
        eventType: "content_impression",
      }
    );
    console.log(`Matomo ${actionType} event sent for Watchlist`);
  };



    // Common helper function
  export const sendLiveChannelEvent = async ({
    actionType, // Play, Pause, Resume, Stop
    itemData,
    itemDetails,
  }) => {
    const genres = itemDetails?.[0]?.genres;
    const actionName = genres
      ? `${itemData?.id}/${itemData?.title}-${genres}`
      : `${itemData?.id}/${itemData?.title}`;
    const ciValue = `LiveChannel/${actionType}`;

    // Interaction
    await sendTestMatomoEvent(
      {
        action_name: actionName,
      },
      {
        eventType: "content_interaction",
        c_i: ciValue,
      }
    );

    // Impression
    await sendTestMatomoEvent(
      {
        action_name: actionName,
      },
      {
        eventType: "content_impression",
      }
    );

    // console.log(`Matomo ${actionType} event sent for LiveChannel`);
  };